// get table detail exco pusat
export const GET_DETAIL_TABLE_EXCO_PUSAT = "GET_DETAIL_TABLE_EXCO_PUSAT";
export const GET_DETAIL_TABLE_EXCO_PUSAT_SUCCESS =
  "GET_DETAIL_TABLE_EXCO_PUSAT_SUCCESS";
export const GET_DETAIL_TABLE_EXCO_PUSAT_FAIL =
  "GET_DETAIL_TABLE_EXCO_PUSAT_FAIL";

// post table pengurus
export const POST_DETAIL_TABLE_EXCO_PUSAT = "POST_DETAIL_TABLE_EXCO_PUSAT";
export const POST_DETAIL_TABLE_EXCO_PUSAT_SUCCESS =
  "POST_DETAIL_TABLE_EXCO_PUSAT_SUCCESS";
export const POST_DETAIL_TABLE_EXCO_PUSAT_FAIL =
  "POST_DETAIL_TABLE_EXCO_PUSAT_FAIL";

// patch table pengurus
export const PATCH_DETAIL_TABLE_EXCO_PUSAT = "PATCH_DETAIL_TABLE_EXCO_PUSAT";
export const PATCH_DETAIL_TABLE_EXCO_PUSAT_SUCCESS =
  "PATCH_DETAIL_TABLE_EXCO_PUSAT_SUCCESS";
export const PATCH_DETAIL_TABLE_EXCO_PUSAT_FAIL =
  "PATCH_DETAIL_TABLE_EXCO_PUSAT_FAIL";

// DELETE table pengurus
export const DELETE_DETAIL_TABLE_EXCO_PUSAT = "DELETE_DETAIL_TABLE_EXCO_PUSAT";
export const DELETE_DETAIL_TABLE_EXCO_PUSAT_SUCCESS =
  "DELETE_DETAIL_TABLE_EXCO_PUSAT_SUCCESS";
export const DELETE_DETAIL_TABLE_EXCO_PUSAT_FAIL =
  "DELETE_DETAIL_TABLE_EXCO_PUSAT_FAIL";
// get user table pengurus
export const GET_USER_DETAIL_TABLE_EXCO_PUSAT =
  "GET_USER_DETAIL_TABLE_EXCO_PUSAT";
export const GET_USER_DETAIL_TABLE_EXCO_PUSAT_SUCCESS =
  "GET_USER_DETAIL_TABLE_EXCO_PUSAT_SUCCESS";
export const GET_USER_DETAIL_TABLE_EXCO_PUSAT_FAIL =
  "GET_USER_DETAIL_TABLE_EXCO_PUSAT_FAIL";

// lock unlock exco
export const POST_LOCK_UNLOCK_EXCO = "POST_LOCK_UNLOCK_EXCO";
export const POST_LOCK_UNLOCK_EXCO_SUCCESS = "POST_LOCK_UNLOCK_EXCO_SUCCESS";
export const POST_LOCK_UNLOCK_EXCO_FAIL = "POST_LOCK_UNLOCK_EXCO_FAIL";
